<template>
  <el-dialog
    title="每日任务详情"
    :visible="visible"
    width="900px"
    append-to-body
    :close-on-click-modal="false"
    @close="$emit('update:visible', false)"
  >
    <div
      v-loading="loading"
      class="detail-container"
    >
      <template v-if="task.uuid">
        <DailyTaskInfo :task="task" />
        <template v-if="taskImageIds.length">
          <div class="section-title mt-4">
            任务图片
          </div>
          <ImageThumbViewer
            :file-ids="taskImageIds"
            variant="compact"
            preview-width="640px"
          />
        </template>
        <template v-if="feedbackImageIds.length">
          <div class="section-title mt-4">
            现场及异常图片
          </div>
          <ImageThumbViewer
            :file-ids="feedbackImageIds"
            variant="compact"
            preview-width="640px"
          />
        </template>
      </template>
    </div>
    <div slot="footer">
      <el-button @click="$emit('update:visible', false)">
        关闭
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import ImageThumbViewer from '@/features/components/common-image/ImageThumbViewer.vue';
import { parseImageFileIds, uniqueFileIds } from '@/features/components/common-image/imageFileIdsUtil.js';
import DailyTaskInfo from './DailyTaskInfo.vue';
import { dailyTaskService, unwrap } from './daily-task.service';

export default {
  name: 'DailyTaskDetailDialog',
  components: { DailyTaskInfo, ImageThumbViewer },
  props: {
    visible: Boolean,
    taskId: { type: String, required: true }
  },
  data () {
    return {
      task: {},
      loading: false
    };
  },
  computed: {
    taskImageIds () {
      return parseImageFileIds(this.task.taskImageFileIds);
    },
    feedbackImageIds () {
      return uniqueFileIds([
        ...parseImageFileIds(this.task.imageFileIds),
        ...parseImageFileIds(this.task.faultImageFileIds)
      ]);
    }
  },
  methods: {
    async load () {
      this.loading = true;
      try {
        this.task = unwrap(await dailyTaskService.detail(this.taskId));
      } catch (e) {
        this.$message.error('任务详情加载失败');
      } finally {
        this.loading = false;
      }
    }
  },
  created () {
    this.load();
  }
};
</script>

<style scoped>
.detail-container {
  padding: 0 4px;
}
.section-title {
  margin-bottom: 14px;
  padding-left: 10px;
  border-left: 4px solid #409eff;
  color: #303133;
  font-size: 15px;
  font-weight: 600;
  line-height: 1.1;
}
.mt-4 {
  margin-top: 20px;
}
</style>
